// extracted by mini-css-extract-plugin
module.exports = {"RichText":"styles_RichText__mvI9j","uppercaseLink":"styles_uppercaseLink__MocbC","link":"styles_link__R5lyU"};